import { render } from "./AntivirusPremium.vue?vue&type=template&id=58c85cb8&scoped=true"
import script from "./AntivirusPremium.vue?vue&type=script&lang=js"
export * from "./AntivirusPremium.vue?vue&type=script&lang=js"

import "./AntivirusPremium.vue?vue&type=style&index=0&id=58c85cb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58c85cb8"

export default script